export default {
	chart: state => key => state.charts[key.toLowerCase()] || [],
	entity: state => (type, id) => state.entities[type][id] || {},
	getTime: state => state.time,
	isSharedChart: state => state.sharedChart,
	isImageChart: state => state.imageChart
};
